import { useState } from 'react'
import { ChevronLeft } from 'lucide-react'

const PhoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 16.92V19.92C22.0011 20.1986 21.9441 20.4742 21.8325 20.7294C21.7209 20.9846 21.5573 21.2137 21.3521 21.4019C21.1468 21.5901 20.9046 21.7336 20.6407 21.8228C20.3769 21.912 20.0974 21.9452 19.82 21.92C16.7428 21.5857 13.787 20.5342 11.19 18.85C8.77382 17.3147 6.72534 15.2662 5.19 12.85C3.50003 10.2412 2.44824 7.27101 2.12 4.18C2.09501 3.90347 2.12759 3.62476 2.21605 3.36162C2.3045 3.09849 2.44701 2.85687 2.63412 2.65162C2.82123 2.44638 3.04898 2.28237 3.30296 2.16962C3.55694 2.05687 3.83144 1.99875 4.11 2H7.11C7.5953 1.99522 8.06581 2.16708 8.43374 2.48353C8.80168 2.79999 9.04205 3.23945 9.11 3.72C9.23662 4.68007 9.47144 5.62273 9.81 6.53C9.92152 6.83772 9.94801 7.17132 9.88655 7.49354C9.82509 7.81575 9.67832 8.11357 9.46 8.36L8.09 9.73C9.51352 12.3104 11.6496 14.4465 14.23 15.87L15.6 14.5C15.8464 14.2817 16.1443 14.1349 16.4665 14.0735C16.7887 14.012 17.1223 14.0385 17.43 14.15C18.3373 14.4886 19.2799 14.7234 20.24 14.85C20.7206 14.918 21.16 15.1584 21.4765 15.5263C21.7929 15.8943 21.9648 16.3647 21.96 16.85H22V16.92Z" fill="white"/>
  </svg>
)

const WechatIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5 14C8.5 14 8 14 8 13.5C8 13 8.5 12.5 9 12.5C9.5 12.5 10 13 10 13.5C10 14 9.5 14.5 9 14.5C8.5 14.5 8.5 14 8.5 14ZM12.5 14C12.5 14 12 14 12 13.5C12 13 12.5 12.5 13 12.5C13.5 12.5 14 13 14 13.5C14 14 13.5 14.5 13 14.5C12.5 14.5 12.5 14 12.5 14ZM16.5 14C16.5 14 16 14 16 13.5C16 13 16.5 12.5 17 12.5C17.5 12.5 18 13 18 13.5C18 14 17.5 14.5 17 14.5C16.5 14.5 16.5 14 16.5 14ZM20 8.5C20 8.5 19.5 8 19 8C18.5 8 18 8.5 18 9C18 9.5 18.5 10 19 10C19.5 10 20 9.5 20 9C20 8.5 20 8.5 20 8.5ZM4 8.5C4 8.5 3.5 8 3 8C2.5 8 2 8.5 2 9C2 9.5 2.5 10 3 10C3.5 10 4 9.5 4 9C4 8.5 4 8.5 4 8.5ZM12 2C6.5 2 2 6 2 10.5C2 13 3.5 15.5 6 17C6 17 6 19 5 20C5 20 8.5 19.5 10.5 18C11 18 11.5 18 12 18C17.5 18 22 14 22 9.5C22 5 17.5 1 12 2Z" fill="white"/>
  </svg>
)

export default function ContactSidebar() {
  const [isOpen, setIsOpen] = useState(false)

  const contactInfo = [
    {
      icon: <PhoneIcon />,
      title: '联系电话',
      content: '4009850539',
      color: 'bg-primary-600'
    },
    {
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="white"/>
      </svg>,
      title: '邮箱',
      content: '1380632@gmail.com',
      color: 'bg-primary-600'
    },
    {
      icon: <WechatIcon />,
      title: '微信',
      content: '18553917999',
      color: 'bg-primary-600'
    }
  ]

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden md:block fixed right-0 top-1/2 transform -translate-y-1/2 z-50">
        {/* Sidebar */}
        <div className={`bg-white rounded-l-2xl shadow-xl border border-secondary-100 transition-all duration-300 ease-in-out ${isOpen ? 'w-64' : 'w-16'}`}>
          <div className="flex flex-col items-center py-4">
            {/* Toggle button */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="w-12 h-12 rounded-full bg-primary-600 text-white flex items-center justify-center mb-6 hover:bg-primary-700 transition-colors"
            >
              <ChevronLeft className={`w-6 h-6 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {/* Contact items */}
            <div className="space-y-4 w-full">
              {contactInfo.map((item, index) => {
                return (
                  <div key={index} className={`flex items-center p-3 ${isOpen ? 'justify-start' : 'justify-center'} gap-3`}>
                    <div className={`w-10 h-10 rounded-full ${item.color} text-white flex items-center justify-center flex-shrink-0`}>
                      {item.icon}
                    </div>
                    {isOpen && (
                      <div className="flex flex-col">
                        <span className="text-sm text-secondary-500">{item.title}</span>
                        <span className="text-sm font-medium text-secondary-900">{item.content}</span>
                      </div>
                    )}
                  </div>
                )}
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Contact Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-secondary-200 z-40 py-3">
        <div className="flex justify-around items-center">
          {contactInfo.map((item, index) => {
            return (
              <div 
                key={index} 
                className="flex flex-col items-center gap-1"
                onClick={() => {
                  // 显示联系方式
                  if (item.title === '联系电话') {
                    // 对于联系电话，我们可以显示一个提示
                    alert('联系电话：4009850539');
                  } else if (item.title === '邮箱') {
                    // 对于邮箱，我们可以显示一个提示
                    alert('邮箱：1380632@gmail.com');
                  } else if (item.title === '微信') {
                    // 对于微信，我们可以显示一个提示
                    alert('微信：18553917999');
                  }
                }}
              >
                <div className={`w-12 h-12 rounded-full ${item.color} text-white flex items-center justify-center cursor-pointer`}>
                  {item.icon}
                </div>
                <span className="text-xs text-secondary-600">{item.title}</span>
              </div>
            )}
          )}
        </div>
      </div>
    </>
  )
}